<div class="mainpage-container">
  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
      <button class="retry-button" (click)="loadMainPageData()">{{ 'GLOBAL.RETRY' | translate }}</button>
    </div>
  </div>
  <div class="content" *ngIf="!loading() && !error; else loadingTemplate">
    <div class="summary-section">
      <h2>{{ 'MAINPAGE.OVERVIEW' | translate }}</h2>
      <div class="summary-grid">
        <div class="summary-card" *ngFor="let summary of notificationSummary" (click)="onSummaryCardClick(summary)"
          [class.transactions-card]="summary.type === 0" [style.border-left-color]="summary.color">
          <div class="summary-left">
            <div class="summary-icon" [style.color]="summary.color">
              <mat-icon>{{ summary.icon }}</mat-icon>
            </div>
            <div class="summary-category">{{ summary.typeNameKey | translate }}</div>
          </div>
          <div class="summary-content">
            <div class="counter-item" *ngIf="summary.type !== 0">
              <div class="summary-count">{{ summary.count || 0 }}</div>
              <div class="summary-label">{{ 'MAINPAGE.UNREAD_TRANSACTIONS' | translate }}</div>
            </div>
            <div *ngIf="summary.type === 0">
              <div class="counter-item">
                <div class="summary-count">{{ summary.count || 0 }}</div>
                <div class="summary-label">{{ 'MAINPAGE.UNREAD_TRANSACTIONS' | translate }}</div>
              </div>
              <div class="counter-item">
                <div class="summary-count">{{ summary.importedCount || 0 }}</div>
                <div class="summary-label">{{ 'MAINPAGE.IMPORTED_TRANSACTIONS' | translate }}</div>
              </div>
            </div>
          </div>
          <div class="summary-arrow" [style.color]="summary.color">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="recent-section" *ngIf="settings.showRecentNotifications">
      <div class="section-header">
        <h2>{{ 'MAINPAGE.RECENT_NOTIFICATIONS' | translate }}</h2>
      </div>

      <div class="recent-grid" *ngIf="recentNotifications.length > 0">
        <div class="notification-card" *ngFor="let notification of recentNotifications"
          (click)="onNotificationClick(notification)">

          <div class="notification-header">
            <div class="notification-type" [style.color]="getNotificationTypeInfo(notification.type).color">
              <mat-icon class="type-icon">{{ getNotificationTypeInfo(notification.type).icon }}</mat-icon>
              <span class="type-name">{{ getNotificationTypeInfo(notification.type).nameKey | translate }}</span>
            </div>
            <div class="notification-time">{{ formatDate(notification.created) }}</div>
          </div>

          <div class="notification-content">
            <h4 class="notification-title">{{ notification.title }}</h4>
            <p class="notification-preview">{{ getPreviewText(notification.body) }}</p>
          </div>

          <div class="notification-footer">
            <span class="view-detail">{{ 'MAINPAGE.VIEW_DETAIL' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="no-notifications" *ngIf="recentNotifications.length === 0">
        <div class="no-notifications-card">
          <div class="no-notifications-icon">
            <mat-icon>notifications_none</mat-icon>
          </div>
          <h3>{{ 'MAINPAGE.NO_RECENT' | translate }}</h3>
          <p>{{ 'MAINPAGE.NO_RECENT_MESSAGE' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="actions-section" *ngIf="settings.showQuickActions">
      <h2>{{ 'MAINPAGE.QUICK_ACTIONS' | translate }}</h2>
      <div class="actions-grid">
        <button class="action-btn transactions" (click)="navigateToTransactions()">
          <mat-icon class="action-icon">credit_card</mat-icon>
          <span class="action-text">{{ 'MAINPAGE.VIEW_TRANSACTIONS' | translate }}</span>
        </button>
        <button class="action-btn messages" (click)="navigateToMessages()">
          <mat-icon class="action-icon">mail</mat-icon>
          <span class="action-text">{{ 'MAINPAGE.VIEW_MESSAGES' | translate }}</span>
        </button>
        <button class="action-btn tables" (click)="navigateToTables()">
          <mat-icon class="action-icon">table_chart</mat-icon>
          <span class="action-text">{{ 'MAINPAGE.VIEW_TABLES' | translate }}</span>
        </button>
        <button class="action-btn charts" (click)="navigateToCharts()">
          <mat-icon class="action-icon">bar_chart</mat-icon>
          <span class="action-text">{{ 'MAINPAGE.VIEW_CHARTS' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'MAINPAGE.LOADING' | translate }}</p>
    </div>
  </ng-template>
</div>